import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2953c31a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Bulk update tool", -1))
const _hoisted_2 = { class: "text-muted" }
const _hoisted_3 = {
  key: 1,
  class: "row"
}
const _hoisted_4 = { class: "col-lg-8" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted p-0 m-0" }, " 2. Select the configurations to be updated ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "m-0 p-0" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-3" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "col-9"
}
const _hoisted_13 = {
  key: 0,
  class: "col-lg-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_HeaderSection = _resolveComponent("HeaderSection")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_RestaurantIdsInput = _resolveComponent("RestaurantIdsInput")!
  const _component_ConfigurationItems = _resolveComponent("ConfigurationItems")!
  const _component_progress_bar = _resolveComponent("progress-bar")!
  const _component_results_panel = _resolveComponent("results-panel")!
  const _component_MainSection = _resolveComponent("MainSection")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSection, null, {
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: { name: 'Tools' },
            exact: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("Tools")
            ]),
            _: 1
          }),
          _createTextVNode(" / Bulk update tool ")
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_MainSection, null, {
      default: _withCtx(() => [
        (!_ctx.localBulkUpdateConfigurations)
          ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.localBulkUpdateConfigurations)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_RestaurantIdsInput, { onIdsUpdated: _ctx.onIdsUpdated }, null, 8, ["onIdsUpdated"]),
                (_ctx.restaurantIds && _ctx.restaurantIds.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _hoisted_6,
                      _hoisted_7,
                      _createVNode(_component_ConfigurationItems, {
                        items: _ctx.localBulkUpdateConfigurations.configs,
                        onEnabledChanged: _ctx.onEnabledChanged,
                        onIncludedChanged: _ctx.onIncludedChanged
                      }, null, 8, ["items", "onEnabledChanged", "onIncludedChanged"]),
                      _hoisted_8,
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          (!_ctx.formState.isSubmitting)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "btn btn-success submit",
                                disabled: !_ctx.formState.canSubmit,
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submit()))
                              }, " submit ", 8, _hoisted_11))
                            : _createCommentVNode("", true),
                          (_ctx.formState.isSubmitting)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                type: "button",
                                class: "btn btn-danger ml-1",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancel()))
                              }, " cancel "))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.formState.isSubmitting)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createVNode(_component_progress_bar, {
                                value: _ctx.formState.completedPercentage
                              }, null, 8, ["value"])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.updateResults && _ctx.updateResults.size > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_results_panel, {
                      results: _ctx.updateResults,
                      elapsedTime: _ctx.formState.lastElapsedTime
                    }, null, 8, ["results", "elapsedTime"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}